module.exports = __webpack_public_path__ + "img/logo-company-4.878ed4aa.png";